import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

import { ContentPageDetailModel } from '../../models/contentPage';
import { ContentPageService } from '../../services';

@Component({
    selector: 'content-page',
    templateUrl: './content.page.component.html'
})

export class ContentPageComponent implements OnInit {

    private pageId: number;

    model: ContentPageDetailModel = new ContentPageDetailModel();

    constructor(private router: Router,
        private contentPageService: ContentPageService) {
        const url = this.router.url;
        if (url.indexOf('about-us') !== -1) {
            this.pageId = 1;
        }
    }

    ngOnInit() {
        this.contentPageService.getPage(this.pageId)
            .subscribe(
                (data: any) => {
                    Object.assign(this.model, data);
                },
                error => {
                    console.log(error);
                });
    }
}




// WEBPACK FOOTER //
// ./src/components/content-page/content.page.component.ts